export default __webpack_public_path__ + "static/media/deadlift.4ada1e51.svg";